<template>
  <div class="f-col form-input-container">
    <template v-if="type === 1">
      <span :class="['t1-form-input-tip', fontColor]" v-show="focused || value">{{ placeholder }}</span>
    </template>
    <template v-else-if="type === 2">
      <span :class="['t2-form-input-tip', fontColor]" v-show="focused || value">{{ placeholder }}</span>
    </template>
    <template v-if="input === 'textarea'">
      <textarea
        :class="['form-textarea', fontColor]"
        :placeholder="(!focused) ? placeholder : ''"
        :aria-label="placeholder"
        :value="value"
        @input="handleInput"
        @focus="focused = true"
        @blur="focused = false"
      ></textarea>
    </template>
    <template v-else>
      <input
        :class="['form-input', fontColor]"
        :type="input"
        :placeholder="(!focused) ? placeholder : ''"
        :aria-label="placeholder"
        :value="value"
        :maxlength="max"
        @input="handleInput"
        @focus="focused = true"
        @blur="focused = false"
        @keyup="handleKeyUpEvents"
      />
    </template>
  </div>
</template>

<script>
export default {
  name: "FormInput",
  props: {
    type: Number,
    value: String,
    input: String,
    max: String,
    placeholder: String,
    fontColor: String,
  },
  data() {
    return {
      focused: false,
    };
  },
  methods: {
    handleKeyUpEvents(evt) {
      this.$emit("keyup", evt);
    },
    handleInput(evt) {
      this.$emit("change", evt.target.value);
    },
  },
};
</script>

<style scoped>
.form-input-container {
  position: relative;
  width: 100%;
}

.t1-form-input-tip {
  position: absolute;
  top: 6px;
  left: 8px;
  user-select: none;
  font-size: 11px;
  font-weight: 400;
  color: #888;
}

.t2-form-input-tip {
  position: absolute;
  top: -2px;
  left: 8px;
  padding: 2px 6px;
  user-select: none;
  font-size: 11px;
  font-weight: 400;
  border-radius: 4px;
  color: var(--primary-font-color);
  background-color: var(--primary-color);
}

.form-input {
  height: 48px;
  padding: 4px 10px 0 10px;
  font-size: 16px;
  outline: none;
  color: #202020;
  margin: 6px 2px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.05);
}

.form-textarea {
  height: 20vh;
  padding: 18px 10px 9px 10px;
  resize: none;
  font-size: 16px;
  outline: none;
  color: #202020;
  margin: 6px 2px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.05);
}

.black {
  color: #303030;
}

.black::placeholder {
  color: #303030;
}

.white {
  color: #f1f1f1;
}

.white::placeholder {
  color: #f1f1f1;
}
</style>